module.exports = __webpack_public_path__ + "res/img_usage_type_branding.c0639a72a0d34e2db0dd2ef614abfbb5.png";